import { useCallback, useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import _, { isArray } from 'lodash';
import { useSelector } from 'react-redux';
import { i18n } from '../../../../language';
import DiaLog from '../../../../components/Dialog';
import { ADS_TYPE } from '../../../../comm/constant';
import { equipmentAPI, systemAPI } from '../../../../apis';
import { useGetUserInfo } from '../../../../utils';
const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '43.75rem',
    },
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
      width: '67rem',
      padding: '1.625rem',
      display: 'flex',
      overflowY: 'auto',
      flexDirection: 'column',
    },
    '& .MuiAlert-root': {
      padding: '6px 16px',
      flexDirection: 'row',
      fontWeight: '400',
      fontFamily: 'NotoSans-Medium',
    },
    '& .MuiAlert-filledError': {
      width: 'auto',
      height: 'auto',
      backgroundColor: '#f44336',
    },
    '& .MuiPaper-elevation6': {
      boxShadow:
        '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
    },
  },
  adsPopContent: ({ type }) => ({
    fontSize: '1rem',
    color: '#2e4469',
    fontFamily: 'NotoSans-Medium',
    paddingBottom: type === ADS_TYPE.MULTIPLE ? '1.5rem' : '0',
    '&>span': {
      color: '#ff655c',
    },
  }),
}));
const DiaLogADS = ({
  tableList,
  setTableList,
  handleClose,
  formData,
  setFormData,
  currentLocation,
  transferSatelliteStoresId,
  categorySatelliteStoresId,
  currentLocationText,
  isCssdReturnSatelliteStore,
}) => {
  const [type, setType] = useState('');
  const classes = useStyles({ type });
  const loginInfo = useSelector((state) => state.loginInfo);
  const [statusIndex, setStatusIndex] = useState(0);
  const [list, setList] = useState([]);
  const [adsLocation, setAdsLocation] = useState();
  const userInfo = useGetUserInfo();
  const [wardLocation, setWardLocation] = useState([]);
  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [open, setOpen] = useState(false);
  // satellite store 类型的ADS
  const satelliteStoreAds = transferSatelliteStoresId !== categorySatelliteStoresId || isCssdReturnSatelliteStore;

  const getWardLocation = useCallback(async () => {
    try {
      const { result } = await systemAPI.getAdsList({ hospitalCode: userInfo.hospCode });
      setWardLocation(result.ADSInfoDetails);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getServiceType = useCallback(async () => {
    try {
      const { result } = await systemAPI.getAdsServiceType({ hospitalCode: userInfo.hospCode });
      setServiceTypeList(result.ADSInfoDetails);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const locationDesc = useMemo(() => {
    let provider = '';
    let request = '';

    if (isArray(wardLocation) && wardLocation.length > 0) {
      provider = _.find(wardLocation, (item) => item.locationCode === adsLocation?.fromLocation)?.locationDesc;
      request = _.find(wardLocation, (item) => item.locationCode === adsLocation?.toLocation)?.locationDesc;
    }

    return {
      provider,
      request,
    };
  }, [wardLocation, adsLocation, tableList, statusIndex]);

  // Create ADS
  const createAdsApi = useCallback(
    async (listADS, isAdsServer) => {
      try {
        let params = {
          adsCategoryId: tableList[statusIndex].categoryId,
          currentLocation,
          currentWard: loginInfo.wardId,
          equipments: listADS,
          instCode: tableList?.[statusIndex]?.hospCode,
          isAdsServer,
          loanType: formData.equipmentStatus === 5 ? 'RETURN' : 'SATELLITESTORES',
          status: formData.equipmentStatus,
          wardId: loginInfo.wardId,
          categorySatelliteStoresId: tableList[statusIndex].categorySatelliteStoresId,
          transferSatelliteStoresId,
          assetId: tableList[statusIndex].assetId,
          adsWardLocationId: tableList[statusIndex].adsWardLocationId,
        };
        await equipmentAPI.updateEquipmentStatus(params);

        if (statusIndex >= tableList.length - 1) {
          setTableList((oldList) =>
            _.filter(oldList, (item) => _.some(list, (xItem) => xItem.assetId === item.assetId))
          );
          setFormData((preData) => ({ ...preData, equipmentStatus: '' }));
          handleClose();
        } else {
          setOpen(false);
          setStatusIndex(statusIndex + 1);
        }
      } catch (error) {
        console.log(error, 'error');
      }
    },
    [loginInfo, tableList, adsLocation, formData]
  );

  // Confirm Create ADS
  const handleConfirm = (isAdsServer) => () => {
    let listADS = [];
    listADS.push(tableList[statusIndex]);
    (async () => {
      await createAdsApi(listADS, isAdsServer);
    })();
  };

  // ADS Location
  const getAdsLocationApi = useCallback(async () => {
    try {
      let locationParams = {
        providerWard: tableList[statusIndex].provideWardId,
        requestWard: tableList[statusIndex].wardId,
        adsWardLocationId: tableList[statusIndex].adsWardLocationId,
        categorySatelliteStoresId: tableList[statusIndex].categorySatelliteStoresId,
        hospitalCategoryId: tableList[statusIndex].categoryId,
        transferSatelliteStoresId,
        loanType: formData.equipmentStatus === 5 ? 'RETURN' : 'SATELLITESTORES',
        assetId: tableList[statusIndex].assetId,
      };
      let serviceTypeParams = {
        hospitalCategoryIds: [tableList[statusIndex].categoryId],
      };
      const { result } = await equipmentAPI.getAdsLocation(locationParams);
      const { result: serviceTypeResult } = await equipmentAPI.getServiceType(serviceTypeParams);
      await getServiceType();
      setAdsLocation({ ...result, ...serviceTypeResult });
      console.log('categorySatelliteStoresId', { categorySatelliteStoresId, transferSatelliteStoresId });

      if (satelliteStoreAds) {
        // 修改了categorySatelliteStoresId之后，并且satelliteStoresTransferEnableYn为1的时候才弹ADS
        if (serviceTypeResult?.CategoryServiceType?.[0]?.satelliteStoresTransferEnableYn === 1) {
          setOpen(true);
          if (result.fromLocation && result.toLocation) {
            setType(ADS_TYPE.SINGLE);
          } else {
            setType(ADS_TYPE.MISSING);
          }
        } else {
          setOpen(false);
          handleConfirm('FALSE')();
        }
        return;
      }

      // returning
      if (serviceTypeResult?.CategoryServiceType?.[0]?.adsReturnEnableYn === 1) {
        if (result.fromLocation && result.toLocation) {
          setOpen(true);
          setType(ADS_TYPE.SINGLE);
        } else {
          setOpen(true);
          setType(ADS_TYPE.MISSING);
        }
      } else {
        setOpen(false);
        handleConfirm('FALSE')();
      }
    } catch (error) {
      console.log(error, 'error');
    }
  }, [tableList, statusIndex, getServiceType, categorySatelliteStoresId, transferSatelliteStoresId, satelliteStoreAds]);

  // close popup
  const handleCloseBtn = () => {
    setList((oldTableList) => [...oldTableList, tableList[statusIndex]]);
    if (statusIndex >= tableList.length - 1) {
      const stayList = [...list, tableList[statusIndex]];
      setTableList((oldList) =>
        _.filter(oldList, (item) => _.some(stayList, (xItem) => xItem.assetId === item.assetId))
      );
      handleClose();
    } else {
      setOpen(false);
      setStatusIndex(statusIndex + 1);
    }
  };

  const copywriting = useMemo(() => {
    switch (type) {
      case ADS_TYPE.SINGLE:
        return {
          title: i18n.t('EQUIPMENT_ADS_POPUP_CREATE_TITLE'),
          content: i18n.t(
            satelliteStoreAds
              ? // 改变 satellite store 的copywriting
                'EQUIPMENT_ADS_POPUP_TRANSFER_SATELLITE_STATUS_CONTENT'
              : // return 时候的copywriting
                'EQUIPMENT_ADS_POPUP_CREATE_STATUS_CONTENT',
            {
              assetId: tableList?.[statusIndex]?.assetId,
              provider: locationDesc.provider,
              request: locationDesc.request,
              serviceType: _.find(
                serviceTypeList,
                (item) =>
                  item?.serviceCid ===
                  (satelliteStoreAds
                    ? adsLocation?.CategoryServiceType?.[0]?.satelliteStoresTransferServiceType
                    : adsLocation?.CategoryServiceType?.[0]?.adsReturnServiceType)
              )?.serviceDesc,
            }
          ),
          cancel: i18n.t('EQUIPMENT_ADS_POPUP_SKIP'),
          confirm: i18n.t('EQUIPMENT_ADS_POPUP_CONFIRM'),
        };
      case ADS_TYPE.MISSING: {
        return {
          title: i18n.t('EQUIPMENT_ADS_POPUP_CREATE_MISSING_TITLE'),
          content: i18n.t(
            satelliteStoreAds
              ? // 改变 satellite store 的copywriting
                'EQUIPMENT_ADS_POPUP_CREATE_MISSING_SATELLITE_STORE_STATUS_CONTENT'
              : // return 时候的copywriting
                'EQUIPMENT_ADS_POPUP_CREATE_MISSING_STATUS_CONTENT',
            {
              assetId: tableList?.[statusIndex]?.assetId,
              provider: locationDesc.provider ?? '<span> N/A </span>',
              request: locationDesc.request ?? '<span> N/A </span>',
              missing: adsLocation?.missingLocation?.join(', '),
              // missing: [
              //   locationDesc.provider
              //     ? ''
              //     : `${tableList[statusIndex]?.hospCode}-${tableList[statusIndex]?.provideWardName}`,
              //   locationDesc.request ? '' : `${tableList[statusIndex]?.hospCode}-${tableList[statusIndex]?.wardName}`,
              // ]
              //   .filter((item) => item)
              //   .join(','),
              currentLocation: currentLocationText,
            }
          ),
          cancel: i18n.t('EQUIPMENT_ADS_POPUP_NO'),
          confirm: i18n.t('EQUIPMENT_ADS_POPUP_YES'),
        };
      }
      default:
        return {
          title: '',
          content: '',
          confirm: '',
        };
    }
  }, [
    type,
    statusIndex,
    tableList,
    adsLocation,
    locationDesc,
    serviceTypeList,
    currentLocationText,
    categorySatelliteStoresId,
    transferSatelliteStoresId,
    satelliteStoreAds,
  ]);

  useEffect(() => {
    (async () => {
      await getAdsLocationApi();
    })();
  }, [getAdsLocationApi]);

  useEffect(() => {
    (async () => {
      await getWardLocation();
    })();
  }, [getWardLocation]);

  return (
    <DiaLog
      open={open}
      title={copywriting.title}
      cancel={copywriting.cancel}
      confirm={copywriting.confirm}
      handleClose={handleCloseBtn}
      handleCancel={adsLocation?.fromLocation && adsLocation?.toLocation ? handleConfirm('FALSE') : handleCloseBtn}
      handleConfirm={handleConfirm(type === ADS_TYPE.SINGLE ? 'TRUE' : 'FALSE')}
      cancelStyle={{ border: 'unset' }}
      dialogfootStyle={{ borderTop: '1px solid #e4e7eb', paddingTop: '1.5rem' }}
    >
      <div className={classes.adsPopContent} dangerouslySetInnerHTML={{ __html: copywriting.content }} />
    </DiaLog>
  );
};
export default DiaLogADS;
